
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rotate-pdf",
      function () {
        return require("private-next-pages/rotate-pdf.js");
      }
    ]);
  